// Seletor de mês da Clínica (Dashboard e Financeiro). O mês fica na URL
// (?mes=AAAA-MM) para valer em todas as abas; a tela implementa onMonthChanged() para
// buscar de novo. Os meses são do calendário (não são dados de negócio).
import { recentMonths } from "@/data/clinica";

export const MONTH_COUNT = 6;

// Últimos meses como { value: AAAA-MM, label: "Outubro de 2026" }.
export function monthOptions(count = MONTH_COUNT, from = new Date()) {
  return recentMonths(count, from).map((label, i) => {
    const d = new Date(from.getFullYear(), from.getMonth() - i, 1);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    return { value: `${d.getFullYear()}-${month}`, label };
  });
}

export default {
  data() {
    const months = monthOptions();
    const requested = this.$route && this.$route.query.mes;
    return {
      months,
      month: months.some(m => m.value === requested)
        ? requested
        : months[0].value
    };
  },
  computed: {
    /** Query das abas: trocar de aba mantém o mês escolhido. */
    monthQuery() {
      return { mes: this.month };
    }
  },
  methods: {
    onMonthChange() {
      const navigation = this.$router.replace({
        query: { ...this.$route.query, mes: this.month }
      });
      // .catch evita o NavigationDuplicated do vue-router 3.
      if (navigation && navigation.catch) navigation.catch(() => {});
      this.onMonthChanged();
    }
  }
};
